import {Injectable} from '@angular/core';
import {EventType, Router} from '@angular/router';
import {filter, map, Observable} from 'rxjs';
import {OnAppInitInterface, Utils} from '@astek/utils';
import {RoutesEnum} from './routes.enum';
import {AuthenticationService} from '../authentication/authentication.service';
import {UserRolesEnum} from '../user/user-roles.enum';

@Injectable()
export class NavigationService implements OnAppInitInterface {

  constructor(
    private readonly _router: Router,
    private readonly _authenticationService: AuthenticationService,
  ) {
  }

  public get currentPage(): RoutesEnum | null {
    for (const route of Object.values(RoutesEnum)) {
      const routeWithoutParams: string = route.replace(/\/[:a-zA-Z]+/g, '');
      if (this._router.url.startsWith(`/${routeWithoutParams}`)) {
        return route;
      }
    }
    return null;
  }

  public get currentPageChanged(): Observable<RoutesEnum | null> {
    return this._router.events.pipe(
      filter(event => event.type === EventType.NavigationEnd),
      map(() => this.currentPage),
    );
  }

  public get defaultRoute(): RoutesEnum {
    if (!this._authenticationService.isAuthenticated) {
      return RoutesEnum.AUTHENTICATION;
    }
    switch (this._authenticationService.user?.roles[0]) {
      case UserRolesEnum.ADMIN:
        return RoutesEnum.USERS;
      case UserRolesEnum.SUBCONTRACTOR:
        return RoutesEnum.SENSORS;
      case UserRolesEnum.PRACTITIONER:
        return RoutesEnum.PATIENTS;
    }
    return RoutesEnum.HOME;
  }

  public onAppInit(): void {
  }

  public navigateTo(page: RoutesEnum | null): Promise<boolean> {
    if (Utils.isNullOrUndefined(page)) {
      return Promise.resolve(false);
    }
    console.log('Navigating to route:', page);
    return this._router.navigate([page]);
  }

  public navigateToSubPage(page: RoutesEnum | null, subpage: string): Promise<boolean> {
    if (Utils.isNullOrUndefined(page)) {
      return Promise.resolve(false);
    }
    console.log('Navigating to route:', page);
    return this._router.navigate([page, subpage]);
  }
}
